<script>
	import Modal from '../modal.svelte'

	export let cast = []

	let activeCastMember = null
</script>

<div class="cast grid-four">
	{#each cast as castMember}
		<div
			class="cast-member grid-item"
			on:click={() => (activeCastMember = castMember)}>
			<div style="background-image:url({castMember.img})" />
			<h5>{castMember.name}</h5>
		</div>
	{/each}
</div>

{#if activeCastMember}
	<Modal on:close={() => (activeCastMember = null)}>
		<div class="cast-modal clearfix">
			<img src={activeCastMember.img} alt="" />
			<div>
				<h2>{activeCastMember.name}</h2>
				{@html activeCastMember.info}
			</div>
		</div>
	</Modal>
{/if}
